import React, { forwardRef, useImperativeHandle } from 'react';
import { Form, Radio, Col } from 'antd';
import { BaseSelect } from '@app/components/common/selects/BaseSelect/BaseSelect';
import { BaseInput } from '@app/components/common/inputs/BaseInput/BaseInput';
import CertificateValidityForm from './CertficateValidityFields';

interface AdditionalInfoFormProps {
  form: any;
  editable: boolean;
  onSubmit: (data: any) => void;
  departmentOptions: any[];
  status: string | null;
  pr_id: string | null;
  canSetValidity: boolean;
}

const AdditionalInfoForm = forwardRef<any, AdditionalInfoFormProps>(
  ({ editable, onSubmit, departmentOptions, form, status, pr_id, canSetValidity }, ref) => {
    const collected_type = Form.useWatch('collected_type', form) || 'TAKEAWAY';

    const handleCollectedFromChange = (value: string) => {
      if (editable) {
        form.setFieldsValue({ collected_type: value });
      }
    };

    const handleFormSubmit = () => {
      const dataToSubmit = form.getFieldsValue();
      onSubmit(dataToSubmit);
      console.log('AdditionalInfo submitted data:', dataToSubmit);
    };

    useImperativeHandle(ref, () => ({
      getData: () => form.getFieldsValue(),
    }));

    const collectedFrom = Form.useWatch('collected_type', form) || 'TAKEAWAY';
    const isFormEditable = editable && (status === null || status === 'DRAFT');

    const user = JSON.parse(localStorage.getItem('user') || '{}')?.name || 'Unknown User';

    return (
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFormSubmit}
        initialValues={{
          collected_type: 'TAKEAWAY',
        }}
      >
        <Col xs={24} md={8} lg={8}>
          <Form.Item
            name="department_id"
            label="Department Related to the Registration"
            rules={[{ required: true, message: 'Department is required' }]}
            getValueProps={(value) => ({
              value: departmentOptions.find((opt) => opt.value === value)?.label || '',
            })}
          >
            {!isFormEditable ? (
              <BaseInput readOnly />
            ) : (
              <BaseSelect placeholder="Select Department" options={departmentOptions} />
            )}
          </Form.Item>
        </Col>

        <Form.Item label="Collected From" name="collected_type">
          <Radio.Group disabled={!isFormEditable}>
            <Radio value="TAKEAWAY">Department</Radio>
            <Radio value="DELIVERY">Courier to Customer Location</Radio>
          </Radio.Group>
        </Form.Item>

        {collected_type === 'DELIVERY' && (
          <Col xs={24} md={8} lg={12}>
            <Form.Item
              name="delivery_address"
              label="Delivery Address"
              rules={[{ required: true, message: 'Delivery address is required' }]}
            >
              <BaseInput placeholder="Enter delivery address" readOnly={!isFormEditable} />
            </Form.Item>
          </Col>
        )}

        {user === 'Admin' &&
          canSetValidity &&
          !['', 'DRAFT', 'PENDING_DOCUMENT', 'PENDING_DOCUMENT_PAYMENT', 'PENDING_REVIEW'].includes(status ?? '') && (
            <CertificateValidityForm form={form} pr_id={pr_id ?? null} status={status} />
          )}
      </Form>
    );
  },
);

export default AdditionalInfoForm;
